import React from 'react'

import { getallDBRdataApi, getEveBreDecision,getEveBreScoreUpdated  } from '../../../../AdminActionCreator.component'

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from "@emotion/styled";

import CreditScoring from './CreditScoring'
import Loader from '../../../../../../presentationals/Loader/Loader.component'

const regenerateParam = 0;

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: '2rem',
    },
}));
class ScoringSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flagData: '',
            scoreDetail: [],
            decisionEv: "",
            loaderState: false
        }
    }
    getData() {

    }
    componentDidMount() {
        this.getFlagData()
        this.getEveBreScoreFunction()

    }
    getFlagData() {
        const { allDetail } = this.props

        getallDBRdataApi(allDetail.userId, callback => {
            console.log("callbackcallback", callback)
            if (callback !== '' && callback !== null) {
                this.setState({ flagData: callback })

            }
        })


    }

    getEveBreScoreFunction() {
        const { allDetail } = this.props
        console.log("allDetailallDetail", allDetail)
        this.setState({ loaderState: true })
        getEveBreScoreUpdated(allDetail?.userId,regenerateParam, (callback) => {
            console.log(callback)
          
          
            this.setState({ scoreDetail: callback})
            this.setState({ loaderState: false })
            this.getEveBreDecisionFunction()
        })


    }
    getEveBreDecisionFunction() {
        const { allDetail } = this.props
        this.setState({ loaderState: true })
        getEveBreDecision(allDetail?.userId, (callback) => {
            console.log(callback)
            this.setState({ decisionEv: callback })
            this.setState({ loaderState: false })
        })
    }

    render() {
        const { allDetail } = this.props;
        console.log("allDetail",allDetail)
        return (
            <>
               
                <div className=" ">
                    <div className='credit-body' >
                        <div className='' style={{ padding: '0px 10px' }}>
                            <div className='internal-score-1'>
                                {
                                    this.state.loaderState ?
                                        <Loader /> : ''
                                }
                                <div style={{ display: 'flex', width: '100%', padding: '10px', background: this.state?.decisionEv?.breDecision === "Approved" ? '#D7FBEA' : "#fee5e3", marginLeft: 'auto', marginRight: 'auto', borderRadius: '6px', borderBottom: this.state?.decisionEv?.breDecision === "Approved" ? '1px solid #00C851' : "1px solid red" }}>
                                    <div className='' style={{ width: '35%' }}>Our Decision
                                       
                                    </div>
                                    
                                </div>
                                <div className='' style={{ background: '#fff', display: 'flex', width: '100%', marginTop: '10px' }}>
                                    <div className='' style={{ width: '50%', border: '1px solid #DBE9FF', borderBottom: '1px solid #DBE9FF', padding: '15px', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}>
                                        <div >
                                            <div>Final Score</div>
                                            <div style={{ fontSize: '18px' }}><b>{this.state?.decisionEv?.breScore}</b></div>
                                            <div>
                                                
                                            </div>

                                        </div>


                                    </div>
                                    <div className='' style={{ width: '50%', border: '1px solid #DBE9FF', borderLeft: 'none', padding: '15px', borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }}>

                                        <div>
                                            <div >Decision</div>
                                            <div style={{ fontSize: '18px' }}><b>{this.state?.decisionEv?.breDecision}</b></div>
                                            <div>
                                             
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                 
                    <CreditScoring allDetail={allDetail} scoreDetail={this.state.scoreDetail} viewType={"view"} />
                   

                    

                </div>
               
            </>
        )
    }
}
export default ScoringSection